import React, { ReactElement } from 'react';
import { LayoutScreenConfig, ScreenType } from '../../../config/FlowTypes';
import { useAppStore } from '../../../store/Store';
import { dispatchUserData } from '../../../store/userData/UserDataActions';
import { ScreenWrapper } from '../../styles/Containers';
import { NavigationProps } from '../FlowNavigation';
import { SingleSelectLayout } from '../layouts/SingleSelectLayout';

export type PapPublicAssistanceLayoutConfig = Record<string, never>;

export type PapPublicAssistanceScreenConfig<ScreenNames extends string> = LayoutScreenConfig<
  ScreenType.PapPublicAssistance,
  PapPublicAssistanceLayoutConfig,
  ScreenNames
>;

type Props<ScreenNames extends string> = NavigationProps<
  PapPublicAssistanceScreenConfig<ScreenNames>,
  ScreenNames
>;

const CHOICES = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' },
];

const EXAMPLES_AU =
  'For example: Health Care Card, Pensioner Concession Card, NDIS, Disability Support Pension';

const EXAMPLES_DEFAULT = 'For example: Medicaid, SNAP, SSI/SSDI, WIC';

export const PapPublicAssistanceScreen = <ScreenNames extends string>(
  props: Props<ScreenNames>
): ReactElement => {
  const country = useAppStore((state) => state.geolocation.country);
  const examples = country === 'AU' ? EXAMPLES_AU : EXAMPLES_DEFAULT;

  function onSelected(value: string) {
    dispatchUserData({ [props.screenName]: [value] });
    props.navigation.next(props);
  }

  return (
    <ScreenWrapper>
      <SingleSelectLayout
        body={[
          'Do you currently hold a government health or income support card or receive equivalent public benefits?',
          examples,
        ]}
        choices={CHOICES}
        onSelected={onSelected}
      />
    </ScreenWrapper>
  );
};
